export default {
  title: 'مدیریت دسته بندی',
  btnAdd:'ایجاد دسته ی جدید',
  loading:'در حال دریافت اطلاعات ...',
  empty:'داده ای یافت نشد'


}
